import axios from 'axios'
// import WordpressRestURI from '@/helpers/WordpressRestURI.js'

/* function getToken () {
  return new Promise((resolve, reject) => {
    axios.get(WordpressRestURI.domainURI + 'wp-json/access/v1/token')
      .then(response => {
        resolve(response.data)
      })
      .catch(e => {
        console.error(e)
        reject(e)
      })
  })
} */

// apiEndpointURI: 'https://apidtgateway.multichoice.co.za/STSAPI/api/ldap',
export default {
// apiEndpointURI: 'https://apisagateway.multichoice.co.za/AuthenticateEmpAPI',
// apiEndpointURIUserDetail: 'https://apisagateway.multichoice.co.za/GetEmpDetailsAPI',

  apiWPBackendURI: 'https://thinktankapi.multichoice.com/ttapi/thinktank_authentication/v1/validateUser',
  apiEndpointURIUserDetail: 'https://thinktankapi.multichoice.com/ttapi/thinktank_authentication/v1/getUserDetail',

  authenticate: function (username, password) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: this.apiWPBackendURI,
        headers: {
          'content-type': 'application/json'
        },
        json: true,
        data: {
          'username': btoa(username),
          'password': btoa(password)
        }
      }).then(response => {
        resolve(response.data)
      }).catch(e => {
        console.error(e)
        reject(e)
      })
    })
  },
  getUserInfoByEmail: function (email) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: this.apiEndpointURIUserDetail + '?email=' + btoa(email)
      }).then(response => {
        resolve(response.data)
      }).catch(e => {
        console.error(e)
        reject(e)
      })
    })
  },
  getUserInfoByUsername: function (username) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: this.apiEndpointURIUserDetail + '?email=' + btoa(username)
      }).then(response => {
        resolve(response.data)
      }).catch(e => {
        console.error(e)
        reject(e)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/helpers/ADauthentication.js